const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20portrait%20avatar%20with%20warm%20peach%20background%2C%20minimalist%20style%2C%20clean%20geometric%20design%2C%20soft%20rounded%20shapes%2C%20modern%20user%20icon&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜群众小李',
    time: '3分钟前',
    content: '这波瓜太香了！五一吃瓜网的信息更新速度是真的快，每次打开都有新内容。建议加个夜间模式，晚上在被窝里吃瓜更方便。',
    likes: '1.2k',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20portrait%20avatar%20with%20soft%20coral%20background%2C%20minimalist%20style%2C%20clean%20geometric%20design%2C%20soft%20rounded%20shapes%2C%20modern%20user%20icon&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '娱乐圈观察员',
    time: '12分钟前',
    content: '作为老用户说句公道话，五一吃瓜网的内容质量在同类平台里算顶尖的。编辑很负责，每条新闻都有标注来源，这点特别好评。',
    likes: '986',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20portrait%20avatar%20with%20warm%20amber%20background%2C%20minimalist%20style%2C%20clean%20geometric%20design%2C%20soft%20rounded%20shapes%2C%20modern%20user%20icon&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '八卦通',
    time: '25分钟前',
    content: '每天上班第一件事就是打开五一吃瓜网看看今天有什么新瓜。覆盖面确实广，从影视到综艺到网红，一个平台全搞定。',
    likes: '756',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20abstract%20portrait%20avatar%20with%20warm%20rose%20background%2C%20minimalist%20style%2C%20clean%20geometric%20design%2C%20soft%20rounded%20shapes%2C%20modern%20user%20icon&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '追星少女小陈',
    time: '40分钟前',
    content: '终于找到一个靠谱的吃瓜平台了！之前看别的网站全是标题党，五一吃瓜网至少每条都有实打实的内容。已经推荐给闺蜜群了。',
    likes: '632',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-chat-1-line text-sm"></i>
            读者热评
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            读者热评
          </h2>
          <p className="text-foreground-500 text-sm mt-2">看看大家怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-sm text-foreground-900">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <div className="flex items-center gap-1 text-foreground-400">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span className="text-xs">{item.likes}</span>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}